import React, { useEffect, useState } from 'react';
import { Button, TextField, Grid, Typography, Box, TableHead, TableRow, TableCell, TableBody, Table, TableContainer, Paper, FormControl, InputLabel, Select, MenuItem, FormGroup, FormControlLabel, Checkbox, Stack, Divider, List, ListItem, ListItemButton, ListItemText, FormLabel, RadioGroup, Radio, FormHelperText } from '@mui/material';
import axios from 'axios';
import jwtAuthAxios from 'app/services/auth/jwtAuth';
import { Link, useParams, useSubmit } from 'react-router-dom';
import useSwalWrapper from "@jumbo/vendors/sweetalert2/hooks";
import * as Yup from "yup"
import { Formik, Form, Field, ErrorMessage } from "formik";
import { DataGrid } from '@mui/x-data-grid';
import { formatDate } from '../accTxn/AccTxn';
import useJumboAuth from '@jumbo/hooks/useJumboAuth';
import BranchTransfer from './branchissret';
const BulkSaleSheetUpload = () => {
  const [file, setFile] = useState(null);
  const [otherdata, setotherdata] = useState(null);
  const [validationResult, setValidationResult] = useState({
    filterdata: [],
    filtersalesmandata: [],
    filtercurrencyndata: [],
  });
  const [isValidated, setIsValidated] = useState(false);
  useEffect(() => {
    const init = async () => {
      await jwtAuthAxios
        .get(
          `master/helper?curr=1&leadgerdetail=21_22&salesman=1`
        ).then((res) => {
          setotherdata(res.data?.data);
        })
        .catch(alert);
    }
    init()
  }, [])
  // Handle file upload
  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  // Handle file submission to the API
  const handleSubmit = async () => {
    if (!file) {
      alert("Please select a file.");
      return;
    }

    const formData = new FormData();
    formData.append('file', file);
    formData.append('validated', isValidated ? 'Yes' : 'No');

    try {
      const response = await jwtAuthAxios.post('transation/bulksheet', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      // Handle API validation response
      if (response.data.status === 'error') {
        // Set validation errors (flags) in state
        setValidationResult({
          filterdata: response.data.filterdata || [],
          filtersalesmandata: response.data.filtersalesmandata || [],
          filtercurrencyndata: response.data.filtercurrencyndata || [],
        });
      } else {
        alert('Bulk data successfully added');
        // Reset validation flags
        setValidationResult({
          filterdata: [],
          filtersalesmandata: [],
          filtercurrencyndata: [],
        });
      }
    } catch (error) {
      console.error("Error uploading bulk sheet:", error);
      alert(error.message);
    }
  };

  return (
    <Box sx={{ p: 2 }}>
      <Grid container justifyContent={'space-between'} alignItems={'center'} spacing={2}>

        <Link to={'/demo/demo_bulk_sale.xlsx'} target='_blank' ><Button type='' variant='outlined'>
          Download Demo File
        </Button></Link>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Button variant="contained" component="label">
            Upload Bulk Sheet
            <input
              type="file"
              hidden
              onChange={handleFileChange}
            />
          </Button>
        </Grid>

        {/* Display validation flags */}
        {validationResult.filterdata.length > 0 && (
          <Grid item xs={12}>
            <Typography color="error">
              This Stone Is not Available: {validationResult.filterdata.join(', ')}
            </Typography>
          </Grid>
        )}
        {validationResult.filtersalesmandata.length > 0 && (
          <Grid item xs={12}>
            <Typography color="error">
              Invalid Salesmen: {validationResult.filtersalesmandata.join(', ')}
            </Typography>
          </Grid>
        )}
        {validationResult.filtercurrencyndata.length > 0 && (
          <Grid item xs={12}>
            <Typography color="error">
              Invalid Currencies: {validationResult.filtercurrencyndata.join(', ')}
            </Typography>
          </Grid>
        )}

        <Grid item xs={12}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            disabled={!file}
          >
            Submit
          </Button>
        </Grid>
      </Grid>
      {otherdata && <Grid container spacing={2} sx={{ mt: 3 }}>
        <Grid item xs={6}>
          <TableContainer component={Paper}>
            <Table border={1} size='small'>
              <TableHead>
                <TableRow>
                  <TableCell colSpan={2}><Typography variant='h3'>Cheat Data Salesman </Typography></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Id</TableCell>
                  <TableCell>Name</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {otherdata?.SALESMAN?.map((_, i) =>
                  <TableRow key={i}>
                    <TableCell>{_.FL_USER_ID}</TableCell>
                    <TableCell>{_.FL_NAME}</TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
        <Grid item xs={6}>

          <TableContainer component={Paper}>
            <Table border={1} size='small'>
              <TableHead>
                <TableRow>
                  <TableCell colSpan={2}><Typography variant='h3'>Cheat Data Bank</Typography></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>ACODE</TableCell>
                  <TableCell>Name</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {otherdata?.leadgerdetail?.map((_, i) =>
                  <TableRow key={i}>
                    <TableCell>{_.ACODE}</TableCell>
                    <TableCell>{_.ANAME}</TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
        <Grid item xs={6}>
          <TableContainer component={Paper}>
            <Table border={1} size='small'>
              <TableHead>
                <TableRow>
                  <TableCell colSpan={2}><Typography variant='h3'>Cheat Data Currency </Typography></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Id</TableCell>
                  <TableCell>Name</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {otherdata?.CURR?.map((_, i) =>
                  <TableRow key={i}>
                    <TableCell>{_.FL_CURRENCY_ID}</TableCell>
                    <TableCell>{_.FL_CURRENCY_NAME} ({_.FL_SYMBOLE})</TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>

      </Grid>}
    </Box>
  );
};

const BulkMemo = () => {
  return 'BulkMemo'

}


const ConsignmentToImport = () => {

  const swal = useSwalWrapper();
  const [billNo, setBillNo] = useState('');
  const [bill, setBill] = useState({});
  // const [trNo, setTrNo] = useState("");
  const { no } = useParams()
  useEffect(() => {
    if (no) { setBillNo(no); handleBlur() }
  }, [])
  const [SelectedStone, setSelectedStone] = useState([]);
  const [SelectedStoneDetail, setSelectedStoneDetail] = useState([]);
  const [SelectedStoneSummery, setSelectedStoneSummery] = useState({});
  const handleResetAll = (callback) => {
    callback()
    setBillNo('')
    setBill({})
    setSelectedStone([])
    setSelectedStoneDetail([])
    setSelectedStoneSummery([])
  }
  const handlenext = () => {
    setSelectedStoneDetail((ssd) => bill?.det?.filter(b => SelectedStone.includes(b.FL_STONE_ID)))
  }
  useEffect(() => {
    let obj = {}
    obj['pcs'] = SelectedStoneDetail.length
    obj['rap'] = SelectedStoneDetail.reduce((a, b) => a + b['FL_RAP_PRICE_US'], 0);
    obj['cts'] = SelectedStoneDetail.reduce((a, b) => a + b['FL_WGT'], 0);
    obj['amt'] = SelectedStoneDetail.reduce((a, b) => a + b['FL_COSTAMT'], 0);
    setSelectedStoneSummery(obj)
  }, [SelectedStoneDetail])
  const validationSchema = Yup.object().shape({
    date: Yup.date().required("Date is required"),
  }); const handleBlur = async (e) => {
    const billNo = e?.target?.value;
    if (!billNo && !no) {
      setBill({})
      return
    }
    let payload = {
      trno: billNo || no,
      trtype: "29",
      full: true
    };
    try {
      const res = await jwtAuthAxios.post(
        "transation/transactionDetailsforupdate",
        payload
      );
      if (res.data?.status === "success") {
        setBill(res?.data?.data || {});
      } else {
        swal.fire({
          icon: "error",
          text: res.data.message,
        });
      }
    } catch {
      swal.fire({
        icon: "error",
        text: "Something went wrong.",
      });
    }
  };
  // const handleCheckboxChange = (FL_STONE_ID, i) => { setBill(prevItems => { prevItems[i].checked = !prevItems[i].checked; return prevItems }); };
  // Columns definition
  const columns = [{ field: "STATUS", headerName: "Status", flex: 1 }, { field: "FL_STONE_ID", headerName: "Stone ID", flex: 1 }, { field: "FL_SHAPE", headerName: "Shape", flex: 1 }, { field: "FL_CARATS", headerName: "Carats", flex: 1 }, { field: "FL_COLOR", headerName: "Color", flex: 1 }, { field: "FL_CLARITY", headerName: "Clarity", flex: 1 }, { field: "FL_KEPT_CTS", headerName: "Kept Date", flex: 1 }, { field: "FL_RET_CTS", headerName: "Return Date", flex: 1 }];
  const handleSubmit = async (values, { resetForm }) => {
    // console.log(values)
    // return
    const payload = {
      ...values,
      trno: billNo,
      type: "29",
      totype: values?.consignmentType == 'return' ? "41" : "46",
      purchaseDate: values.date,
      data: SelectedStone,
    };

    try {
      const res = await jwtAuthAxios.post("transation/bulkprocessreturn", payload);

      if (res.data?.status === "success") {
        swal.fire({
          icon: "success",
          text: res.data.message,
        });
        handleResetAll(resetForm); // Reset the form upon success
        setBill([]); // Clear bill state
      } else {
        swal.fire({
          icon: "error",
          text: res.data.message,
        });
      }
    } catch {
      swal.fire({
        icon: "error",
        text: "Something went wrong.",
      });
    }
  };

  return (
    <div>
      <TextField
        disabled={no}
        size="small"
        name="trno"
        sx={{ mb: 2 }}
        label="Bill NO"
        placeholder="Bill NO"
        fullWidth
        variant="outlined"
        value={billNo}
        onBlur={handleBlur}
        onChange={(e) => setBillNo(e.target.value)}
      />
      {bill?.det?.length > 0 && <List >
        <Grid spacing={1} container>
          <Grid item lg={6}>
            <ListItem sx={{ border: '1px solid', padding: '4px 15px', borderColor: (theme) => theme.palette.primary.main, borderRadius: "5px" }}>
              <ListItemText primary={"Party Name:- " + bill?.mas?.PARTY} />
            </ListItem>
          </Grid>
          <Grid item lg={6}>
            <ListItem sx={{ border: '1px solid', padding: '4px 15px', borderColor: (theme) => theme.palette.primary.main, borderRadius: "5px" }}>
              <ListItemText primary={"Consignment Date :- " + formatDate(bill?.mas?.FL_TRANS_DATE)} />
            </ListItem>
          </Grid>
          <Grid item lg={3}>
            <ListItem sx={{ border: '1px solid', padding: '4px 15px', borderColor: (theme) => theme.palette.primary.main, borderRadius: "5px" }}>
              <ListItemText primary={"Total Cts :- " + (bill?.sum?.CTS)?.toFixed(2)} />
            </ListItem>
          </Grid>
          <Grid item lg={3}>
            <ListItem sx={{ border: '1px solid', padding: '4px 15px', borderColor: (theme) => theme.palette.primary.main, borderRadius: "5px" }}>
              <ListItemText primary={"Total Pcs :- " + (bill?.det?.length)} />
            </ListItem>
          </Grid>

          <Grid item lg={3}>
            <ListItem sx={{ border: '1px solid', padding: '4px 15px', borderColor: (theme) => theme.palette.primary.main, borderRadius: "5px" }}>
              <ListItemText primary={"Total Amt($) :- " + (bill?.mas?.FFL_AMT1?.toFixed(2))} />
            </ListItem>
          </Grid>
          <Grid item lg={3}>
            <ListItem sx={{ border: '1px solid', padding: '4px 15px', borderColor: (theme) => theme.palette.primary.main, borderRadius: "5px" }}>
              <ListItemText primary={"Total Amt(2) :- " + (bill?.mas?.FFL_AMT1 * bill?.mas?.FL_CONV_RATE)?.toFixed(2)} />
            </ListItem>
          </Grid>
          <Grid item lg={4}>
            <ListItem sx={{ border: '1px solid', padding: '4px 15px', borderColor: (theme) => theme.palette.primary.main, borderRadius: "5px" }}>
              <ListItemText primary={"Total Confirm Cts :- " + ((bill?.sum?.KCTS || 0)?.toFixed(2))} />
            </ListItem>
          </Grid>
          <Grid item lg={4}>
            <ListItem sx={{ border: '1px solid', padding: '4px 15px', borderColor: (theme) => theme.palette.primary.main, borderRadius: "5px" }}>
              <ListItemText primary={"Total Return Cts :- " + ((bill?.sum?.RCTS || 0)?.toFixed(2))} />
            </ListItem>
          </Grid>
          <Grid item lg={4}>
            <ListItem sx={{ border: '1px solid', padding: '4px 15px', borderColor: (theme) => theme.palette.primary.main, borderRadius: "5px" }}>
              <ListItemText primary={"Total Available Cts :- " + ((bill?.sum?.CTS - ((bill?.sum?.RCTS || 0) + (bill?.sum?.KCTS)))?.toFixed(2))} />
            </ListItem>
          </Grid>
        </Grid>
      </List>}
      <Divider />
      {/* <hr /> */}
      {(bill?.det?.length > 0 && !SelectedStoneDetail?.length > 0) && <DataGrid
        sx={{ maxWidth: '100%' }}
        rows={bill?.det || []}
        density="compact"
        columns={columns}
        getRowId={(row) => row.FL_STONE_ID} // Ensure unique ID for rows
        // disableSelectionOnClick
        isRowSelectable={(params) => {
          const row = params.row;
          // Disable selection if condition is true
          // console.log((row.FL_KEPT_CTS || 0) + (row.FL_RET_CTS || 0) !== row.FL_CARATS)
          return (row.FL_KEPT_CTS || 0) + (row.FL_RET_CTS || 0) !== row.FL_CARATS;
        }}

        checkboxSelection
        onRowSelectionModelChange={(e) => setSelectedStone(e)}
        pageSize={5}
        rowsPerPageOptions={[5, 10, 20]}
      />}
      {SelectedStoneDetail?.length > 0 ? <><Formik
        initialValues={{ trno: "", date: "", consignmentType: "confirm" }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ values, handleChange, handleReset }) => (
          <>

            <Form>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <Stack direction="row" divider={<Divider orientation="vertical" flexItem />} spacing={2} sx={{ mb: 3, mt: 3 }}>
                    <Button variant='outlined' >Pcs:- {SelectedStoneSummery?.pcs || 0}</Button>
                    <Button variant='outlined' >CTS:- {(SelectedStoneSummery?.cts || 0.00)?.toFixed(2)}</Button>
                    <Button variant='outlined' >Rap:- {(SelectedStoneSummery?.rap || 0)?.toFixed(2)}</Button>
                    <Button variant='outlined' >Amt($):- {(SelectedStoneSummery?.amt || 0)?.toFixed(2)}</Button>
                  </Stack>
                </Grid>
                <Grid item xs={6} sx={{ mb: 3, mt: 3 }}>
                  <Field
                    name="date"
                    as={TextField}
                    type="date"
                    label="Date"
                    fullWidth
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                  />
                  <ErrorMessage
                    name="date"
                    component="div"
                    style={{ color: "red" }}
                  />
                </Grid>
                <Grid item xs={6} style={{ textAlign: "left" }}>

                  <FormControl component="fieldset">
                    <FormLabel component="legend">Consignment Type</FormLabel>
                    <RadioGroup
                      row // Makes the radio buttons horizontal
                      value={values.consignmentType}
                      name='consignmentType'
                      onChange={handleChange}
                    >
                      <FormControlLabel
                        value="confirm"
                        control={<Radio />}
                        label="Consignment Confirm"
                      />
                      <FormControlLabel
                        value="return"

                        control={<Radio />}
                        label="Consignment Return"
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid>
                <Grid item xs={12} style={{ textAlign: "right" }}>
                  <Button
                    type="button"
                    variant="contained"
                    color="primary"
                    style={{ marginRight: 10 }}
                    onClick={() => { setSelectedStoneDetail([]) }}
                  >
                    Back
                  </Button>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    style={{ marginRight: 10 }}
                  >
                    Submit
                  </Button>
                  <Button
                    type="button"
                    variant="outlined"
                    color="secondary"
                    onClick={() => handleResetAll(handleReset)}
                  >
                    Cancel
                  </Button>
                </Grid>
              </Grid>
            </Form>
          </>
        )}
      </Formik>
      </> : bill?.det?.length > 0 && <><Button
        type="button"
        variant="contained"
        color="primary"
        onClick={handlenext}
      >
        Next
      </Button></>}
    </div>
  );
};


const MemoToSold = () => {
  return 'MemoToSold'
}



const BulkProcess = () => {
  const [processname, setProcessName] = useState(null)
  const { type } = useParams()
  useEffect(() => {
    setProcessName(type)
  })

  const BulkCom = () => {
    switch (processname) {
      case 'Sale':
        return <BulkSaleSheetUpload />;
        break;
      case 'Memo':
        return <BulkMemo />;
        break;
      case 'CTI':
        return <ConsignmentToImport />;
        break;
      case 'MTS':
        return <MemoToSold />;
        break;
      case 'BTS':
        return <BranchTransfer />;
        break;
      default:
        return null;
        break;
    }
  }

  return <><Grid container>
    <Grid item lg={6}>
      <Typography variant="h4" gutterBottom>Bulk Process</Typography>
    </Grid>
    <Grid item lg={6}>
      <FormControl sx={{ mb: 2, display: 'block', marginLeft: 'auto', width: 'fit-content' }}>
        <InputLabel shrink={processname !== ''} htmlFor="process-select">
          Select Process
        </InputLabel>
        <Select
          sx={{ width: '100%' }}
          disabled={type}
          value={processname}
          onChange={(e) => setProcessName(e.target.value)}
          label="Select Process"
          inputProps={{
            id: 'process-select', // Ensure the label is properly associated with the select input
          }}
        >
          <MenuItem value={null}>Select Process</MenuItem>
          <MenuItem value={'Sale'}>Bulk Sale</MenuItem>
          <MenuItem value={'Memo'}>Bulk Memo</MenuItem>
          <MenuItem value={'CTI'}>Consignment To Import</MenuItem>
          <MenuItem value={'MTS'}>Memo To Sold</MenuItem>
          <MenuItem value={'BTS'}>Branch Transfer</MenuItem>
        </Select>
      </FormControl>
    </Grid>
  </Grid>
    <Paper sx={{ p: 2 }}><BulkCom /></Paper></>
}
BulkProcess.Modulename = 'BulkProcess'
export default BulkProcess;